import { render } from "./Payout.vue?vue&type=template&id=b195671a"
import script from "./Payout.vue?vue&type=script&lang=js"
export * from "./Payout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__